import {
  CULTURALFITSURVEYADVANCESUCCESS,
  CULTURALFITSURVEYADVANCEFAIL,
} from "../actionTypes";

const initialState = {
  fetch: [],
};

const getfetchAdvanceSurveyReducer = (state = initialState, action) => {
  switch (action.type) {
    case CULTURALFITSURVEYADVANCESUCCESS:
      return {
        ...state,
        fetch: action.payload,
      };
    case CULTURALFITSURVEYADVANCEFAIL:
      return {
        ...state,
        fetch: null,
      };
    default:
      break;
  }
  return state;
};

export default getfetchAdvanceSurveyReducer;
